export const TiktokIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_20150_25884)">
        <path
          d="M19.5004 37.5009C29.1657 37.5009 37.0009 29.6657 37.0009 20.0004C37.0009 10.3352 29.1657 2.5 19.5004 2.5C9.83521 2.5 2 10.3352 2 20.0004C2 29.6657 9.83521 37.5009 19.5004 37.5009Z"
          fill="black"
        />
        <path
          d="M17.0651 17.0495V16.0944C16.7376 16.0496 16.4049 16.0215 16.0651 16.0215C11.974 16.0215 8.64584 19.3497 8.64584 23.4408C8.64584 25.9507 9.90039 28.1719 11.8134 29.5151C10.5781 28.1894 9.8205 26.4134 9.8205 24.4636C9.8205 20.4313 13.0548 17.1426 17.0651 17.0486V17.0495Z"
          fill="#25F4EE"
        />
        <path
          d="M17.2398 27.854C19.065 27.854 20.5539 26.4019 20.6215 24.5934L20.6277 8.43879H23.5793C23.5178 8.10694 23.4844 7.76543 23.4844 7.41602H19.453L19.4469 23.5706C19.3793 25.38 17.8903 26.8312 16.0651 26.8312C15.498 26.8312 14.9634 26.689 14.4937 26.4423C15.11 27.2956 16.1099 27.8548 17.2407 27.8548L17.2398 27.854Z"
          fill="#25F4EE"
        />
        <path
          d="M29.0926 13.9211V13.023C27.9671 13.023 26.918 12.6885 26.0383 12.1152C26.8214 13.0142 27.8854 13.663 29.0926 13.9211Z"
          fill="#25F4EE"
        />
        <path
          d="M26.0383 12.1142C25.1806 11.1292 24.6591 9.84305 24.6591 8.4375H23.5793C23.8637 9.97298 24.775 11.2907 26.0383 12.1142Z"
          fill="#FE2C55"
        />
        <path
          d="M16.0651 20.0536C14.1969 20.0536 12.6764 21.5732 12.6764 23.4423C12.6764 24.7434 13.4147 25.8742 14.4928 26.4413C14.0907 25.8847 13.851 25.2025 13.851 24.4651C13.851 22.5969 15.3716 21.0763 17.2398 21.0763C17.5883 21.0763 17.9228 21.1343 18.2397 21.2326V17.1178C17.9123 17.073 17.5796 17.0449 17.2398 17.0449C17.181 17.0449 17.123 17.0484 17.0642 17.0493V20.2098C16.7482 20.1106 16.4128 20.0536 16.0643 20.0536H16.0651Z"
          fill="#FE2C55"
        />
        <path
          d="M29.0926 13.9219V17.0552C27.0022 17.0552 25.0656 16.3862 23.4844 15.2519V23.4438C23.4844 27.5349 20.1562 30.8631 16.0651 30.8631C14.484 30.8631 13.0179 30.3644 11.8134 29.5181C13.1689 30.9728 15.0994 31.8859 17.2407 31.8859C21.3318 31.8859 24.66 28.5577 24.66 24.4666V16.2747C26.2411 17.4098 28.1778 18.0779 30.2681 18.0779V14.0465C29.8651 14.0465 29.4718 14.0026 29.0935 13.9219H29.0926Z"
          fill="#FE2C55"
        />
        <path
          d="M23.4844 23.442V15.2502C25.0656 16.3853 27.0022 17.0534 29.0926 17.0534V13.9201C27.8854 13.662 26.8214 13.0132 26.0383 12.1142C24.775 11.2907 23.8637 9.97298 23.5792 8.4375H20.6277L20.6215 24.5921C20.5539 26.4015 19.065 27.8527 17.2398 27.8527C16.109 27.8527 15.1091 27.2943 14.4928 26.4401C13.4138 25.8721 12.6764 24.7422 12.6764 23.4411C12.6764 21.5729 14.1969 20.0524 16.0651 20.0524C16.4137 20.0524 16.7482 20.1103 17.0651 20.2086V17.0481C13.0547 17.1421 9.8205 20.4308 9.8205 24.463C9.8205 26.4138 10.5781 28.1889 11.8134 29.5146C13.0188 30.3609 14.484 30.8596 16.0651 30.8596C20.1562 30.8596 23.4844 27.5314 23.4844 23.4403V23.442Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20150_25884">
          <rect width="35" height="35" fill="white" transform="translate(2 2.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
